import React from 'react';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';
import {UserRefLink} from '../../types/TypesUser';
import GreenButton from './GreenButton';
import s from './CopyInHashButton.module.css';

type Props = {
	link: UserRefLink;
};

const CopyInHashButton: React.FC<Props> = ({link}) => {
	const {t} = useTranslation();

	const copyToClipboard = async () => {
		try {
			await navigator.clipboard.writeText(link.ref);
			toast.success('Посилання скопійовано');
		} catch (err) {
			toast.error('Помилка');
		}
	};

	const copyIcon = (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
			<path
				d="M13.3333 6H7.33333C6.59695 6 6 6.59695 6 7.33333V13.3333C6 14.0697 6.59695 14.6667 7.33333 14.6667H13.3333C14.0697 14.6667 14.6667 14.0697 14.6667 13.3333V7.33333C14.6667 6.59695 14.0697 6 13.3333 6Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3.33333 10H2.66667C2.31304 10 1.97391 9.85952 1.72386 9.60948C1.47381 9.35943 1.33333 9.02029 1.33333 8.66667V2.66667C1.33333 2.31304 1.47381 1.97391 1.72386 1.72386C1.97391 1.47381 2.31304 1.33333 2.66667 1.33333H8.66667C9.02029 1.33333 9.35943 1.47381 9.60948 1.72386C9.85952 1.97391 10 2.31304 10 2.66667V3.33333"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);

	return (
		<div className={s.referalItem}>
			<div className={s.referalLabel}>{link.typename}</div>
			<GreenButton
				text={t('копіювати посилання')}
				onClick={copyToClipboard}
				type="button"
				variant="blue"
				icon={copyIcon}
			/>
		</div>
	);
};

export default CopyInHashButton;
